import {
  Paper,
} from '@material-ui/core';
import React, { FunctionComponent } from 'react';

export const PaddedPaper: FunctionComponent = ({children}) => {
  return <Paper elevation={0} style={{padding: "1em"}}>{children}</Paper>
}
